import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { __ } from "@jti/fe-common";
import "./loader.scss";
const Loader = () => {
    const [currentClass, setCurrentClass] = useState("");
    const ref = useRef("");
    ref.current = currentClass;
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentClass(!ref.current.length ? "react-loader__progress-bar--loaded" : "");
        }, 500);
        return () => {
            clearInterval(interval);
        };
    }, []);
    return (_jsxs("div", { className: "react-loader", children: [_jsx("div", { className: "react-loader__progress-bar-container", children: _jsx("div", { className: `react-loader__progress-bar ${currentClass}` }) }), _jsx("div", { className: "react-loader__loader-text", children: __("hero.loading.text") })] }));
};
export default Loader;
//# sourceMappingURL=Loader.js.map